export const searchbarUserHandler = username => {
  return dispatch => {
    dispatch({ type: "SELECTED_SEARCHBAR_USER", username });
  };
};

